import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const AuthModule = () => {
  return {
    state: {
      preview: {
        logo: null,
        name: null
      },
      //todo - feed from data templates
      company: {
        handle: null,
        partner_token: null
      },
      failed: false
    },
    mutations,
    actions,
    getters,
  }
};

export default AuthModule;



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth/index.js